/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import SubstanceUseRow from "./SubstanceUseRow"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { drugsAdministrationTypes } from "../../../types/dropDownTypes"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import { GpraContext } from "../../../../../context/gpraContext"
import {
  showMessage,
  existsErrors,
  getAdditionalQuestions,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  nextForm,
  prevForm,
} from "../../../utils/utils"
import { errorMessages } from "../../../types/messages"
import { Accordion, AccordionTab } from "primereact/accordion"
import FormLabel from "../../../Common/FormLabel"
import gpraSytles from "../../../../../styles/Participant-GPRA.module.css"
import {
  INTERVIEW_SECTIONS,
  INTERVIEW_TYPES,
} from "../../../types/interviewTypes"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"
const SubstanceUse1 = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadNext,
    sectionsCompleted,
    handleSectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    activeIndex,
    sections,
    administrativeInterview,
    interviewType,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [substanceUse1, setSubstanceUse1] = useState(
    interview[INTERVIEW_SECTIONS.SUBSTANCE_USE_1]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])

  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) => q.section === INTERVIEW_SECTIONS.SUBSTANCE_USE_1
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.SUBSTANCE_USE_1
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.SUBSTANCE_USE_1, substanceUse1)
    if (previousForm) {
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SUBSTANCE_USE_DATA, {
          GpraBForm: {
            ...substanceUse1,
            gpra_b_1a1_route: substanceUse1?.gpra_b_1a1_route,
            gpra_b_1a1_days: substanceUse1?.gpra_b_1a1_days,
            gpra_b_1a2_route: substanceUse1?.gpra_b_1a2_route,
            gpra_b_1a2_days: substanceUse1?.gpra_b_1a2_days,
            gpra_b_1a2a: substanceUse1?.gpra_b_1a2a,
            gpra_b_1b1_route: substanceUse1?.gpra_b_1b1_route,
            gpra_b_1b1_days: substanceUse1?.gpra_b_1b1_days,
            gpra_b_1b2_route: substanceUse1?.gpra_b_1b2_route,
            gpra_b_1b2_days: substanceUse1?.gpra_b_1b2_days,
            gpra_b_1b3_route: substanceUse1?.gpra_b_1b3_route,
            gpra_b_1b3_days: substanceUse1?.gpra_b_1b3_days,
            gpra_b_1b4_route: substanceUse1?.gpra_b_1b4_route,
            gpra_b_1b4_days: substanceUse1?.gpra_b_1b4_days,
            gpra_b_1b5_route: substanceUse1?.gpra_b_1b5_route,
            gpra_b_1b5_days: substanceUse1?.gpra_b_1b5_days,
            gpra_b_1b6_route: substanceUse1?.gpra_b_1b6_route,
            gpra_b_1b6_days: substanceUse1?.gpra_b_1b6_days,
            gpra_b_1b7_route: substanceUse1?.gpra_b_1b7_route,
            gpra_b_1b7_days: substanceUse1?.gpra_b_1b7_days,
            gpra_b_1b8_route: substanceUse1?.gpra_b_1b8_route,
            gpra_b_1b8_days: substanceUse1?.gpra_b_1b8_days,
            gpra_b_1b9_route: substanceUse1?.gpra_b_1b9_route,
            gpra_b_1b9_days: substanceUse1?.gpra_b_1b9_days,
            gpra_b_1b10_route: substanceUse1?.gpra_b_1b10_route,
            gpra_b_1b10_days: substanceUse1?.gpra_b_1b10_days,
            gpra_b_1b11_route: substanceUse1?.gpra_b_1b11_route,
            gpra_b_1b11_days: substanceUse1?.gpra_b_1b11_days,
            gpra_b_1b12_route: substanceUse1?.gpra_b_1b12_route,
            gpra_b_1b12_days: substanceUse1?.gpra_b_1b12_days,
            gpra_b_1b12a: substanceUse1?.gpra_b_1b12a,
            gpra_b_1c1_route: substanceUse1?.gpra_b_1c1_route,
            gpra_b_1c1_days: substanceUse1?.gpra_b_1c1_days,
            gpra_b_1c2_route: substanceUse1?.gpra_b_1c2_route,
            gpra_b_1c2_days: substanceUse1?.gpra_b_1c2_days,
            gpra_b_1c3_route: substanceUse1?.gpra_b_1c3_route,
            gpra_b_1c3_days: substanceUse1?.gpra_b_1c3_days,
            gpra_b_1c3a: substanceUse1?.gpra_b_1c3a,
            gpra_b_1d1_route: substanceUse1?.gpra_b_1d1_route,
            gpra_b_1d1_days: substanceUse1?.gpra_b_1d1_days,
            gpra_b_1d2_route: substanceUse1?.gpra_b_1d2_route,
            gpra_b_1d2_days: substanceUse1?.gpra_b_1d2_days,
            gpra_b_1d3_route: substanceUse1?.gpra_b_1d3_route,
            gpra_b_1d3_days: substanceUse1?.gpra_b_1d3_days,
            gpra_b_1d4_route: substanceUse1?.gpra_b_1d4_route,
            gpra_b_1d4_days: substanceUse1?.gpra_b_1d4_days,
            gpra_b_1d5_route: substanceUse1?.gpra_b_1d5_route,
            gpra_b_1d5_days: substanceUse1?.gpra_b_1d5_days,
            gpra_b_1d5a: substanceUse1?.gpra_b_1d5a,
            gpra_b_1e1_route: substanceUse1?.gpra_b_1e1_route,
            gpra_b_1e1_days: substanceUse1?.gpra_b_1e1_days,
            gpra_b_1e2_route: substanceUse1?.gpra_b_1e2_route,
            gpra_b_1e2_days: substanceUse1?.gpra_b_1e2_days,
            gpra_b_1e3_route: substanceUse1?.gpra_b_1e3_route,
            gpra_b_1e3_days: substanceUse1?.gpra_b_1e3_days,
            gpra_b_1e3a: substanceUse1?.gpra_b_1e3a,
            gpra_b_1f1_route: substanceUse1?.gpra_b_1f1_route,
            gpra_b_1f1_days: substanceUse1?.gpra_b_1f1_days,
            gpra_b_1f2_route: substanceUse1?.gpra_b_1f2_route,
            gpra_b_1f2_days: substanceUse1?.gpra_b_1f2_days,
            gpra_b_1f3_route: substanceUse1?.gpra_b_1f3_route,
            gpra_b_1f3_days: substanceUse1?.gpra_b_1f3_days,
            gpra_b_1f3a: substanceUse1?.gpra_b_1f3a,
            gpra_b_1g1_route: substanceUse1?.gpra_b_1g1_route,
            gpra_b_1g1_days: substanceUse1?.gpra_b_1g1_days,
            gpra_b_1g2_route: substanceUse1?.gpra_b_1g2_route,
            gpra_b_1g2_days: substanceUse1?.gpra_b_1g2_days,
            gpra_b_1g3_route: substanceUse1?.gpra_b_1g3_route,
            gpra_b_1g3_days: substanceUse1?.gpra_b_1g3_days,
            gpra_b_1g4_route: substanceUse1?.gpra_b_1g4_route,
            gpra_b_1g4_days: substanceUse1?.gpra_b_1g4_days,
            gpra_b_1g5_route: substanceUse1?.gpra_b_1g5_route,
            gpra_b_1g5_days: substanceUse1?.gpra_b_1g5_days,
            gpra_b_1g6_route: substanceUse1?.gpra_b_1g6_route,
            gpra_b_1g6_days: substanceUse1?.gpra_b_1g6_days,
            gpra_b_1g7_route: substanceUse1?.gpra_b_1g7_route,
            gpra_b_1g7_days: substanceUse1?.gpra_b_1g7_days,
            gpra_b_1g8_route: substanceUse1?.gpra_b_1g8_route,
            gpra_b_1g8_days: substanceUse1?.gpra_b_1g8_days,
            gpra_b_1g8a: substanceUse1?.gpra_b_1g8a,
            gpra_b_1h1_route: substanceUse1?.gpra_b_1h1_route,
            gpra_b_1h1_days: substanceUse1?.gpra_b_1h1_days,
            gpra_b_1h2_route: substanceUse1?.gpra_b_1h2_route,
            gpra_b_1h2_days: substanceUse1?.gpra_b_1h2_days,
            gpra_b_1h2a: substanceUse1?.gpra_b_1h2a,
            gpra_b_1i1_route: substanceUse1?.gpra_b_1i1_route,
            gpra_b_1i1_days: substanceUse1?.gpra_b_1i1_days,
            gpra_b_1i2_route: substanceUse1?.gpra_b_1i2_route,
            gpra_b_1i2_days: substanceUse1?.gpra_b_1i2_days,
            gpra_b_1i3_route: substanceUse1?.gpra_b_1i3_route,
            gpra_b_1i3_days: substanceUse1?.gpra_b_1i3_days,
            gpra_b_1i4_route: substanceUse1?.gpra_b_1i4_route,
            gpra_b_1i4_days: substanceUse1?.gpra_b_1i4_days,
            gpra_b_1i5_route: substanceUse1?.gpra_b_1i5_route,
            gpra_b_1i5_days: substanceUse1?.gpra_b_1i5_days,
            gpra_b_1i6_route: substanceUse1?.gpra_b_1i6_route,
            gpra_b_1i6_days: substanceUse1?.gpra_b_1i6_days,
            gpra_b_1i6a: substanceUse1?.gpra_b_1i6a,
            gpra_b_1i7_route: substanceUse1?.gpra_b_1i7_route,
            gpra_b_1i7_days: substanceUse1?.gpra_b_1i7_days,
            gpra_b_1i7a: substanceUse1?.gpra_b_1i7a,
            gpra_b_1i8_route: substanceUse1?.gpra_b_1i8_route,
            gpra_b_1i8_days: substanceUse1?.gpra_b_1i8_days,
            gpra_b_1i8a: substanceUse1?.gpra_b_1i8a,
            gpra_b_1i9_route: substanceUse1?.gpra_b_1i9_route,
            gpra_b_1i9_days: substanceUse1?.gpra_b_1i9_days,
            gpra_b_1i9a: substanceUse1?.gpra_b_1i9a,
            gpra_b_1i10_route: substanceUse1?.gpra_b_1i10_route,
            gpra_b_1i10_days: substanceUse1?.gpra_b_1i10_days,
            gpra_b_1i10a: substanceUse1?.gpra_b_1i10a,
            gpra_b_1j1_route: substanceUse1?.gpra_b_1j1_route,
            gpra_b_1j1_days: substanceUse1?.gpra_b_1j1_days,
            gpra_b_1j2_route: substanceUse1?.gpra_b_1j2_route,
            gpra_b_1j2_days: substanceUse1?.gpra_b_1j2_days,
            gpra_b_1j3_route: substanceUse1?.gpra_b_1j3_route,
            gpra_b_1j3_days: substanceUse1?.gpra_b_1j3_days,
            gpra_b_1j3a: substanceUse1?.gpra_b_1j3a,
          },
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraBId: substanceUse1?.gpra_b_id,
          Additional: getAdditionalQuestions(substanceUse1),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              handleLoadNext(false)
              setNextForm(
                nextForm(
                  sections,
                  activeIndex,
                  interviewType !== INTERVIEW_TYPES.INTAKE
                    ? administrativeInterview
                    : true
                )
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ substanceUse1: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }
  const validForm = () => {
    const errors = {}

    setValidationErrors(
      validateQuestions(
        substanceUse1,
        INTERVIEW_SECTIONS.SUBSTANCE_USE_1,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }
  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }
  const renderDefaultMain = (question) => {
    if (question.field === "gpra_b_1a1_days") {
      return (
        <Accordion activeIndex={0}>
          <AccordionTab header="Alcohol">
            <SubstanceUseRow
              summaryDisabled={disabled}
              daysSet="gpra_b_1a1_days"
              days={substanceUse1?.gpra_b_1a1_days}
              legend="Alcohol"
              routeOptions={drugsAdministrationTypes}
              routeSet="gpra_b_1a1_route"
              route={substanceUse1?.gpra_b_1a1_route}
              removeError={removeError}
              numberErrorType="gpra_b_1a1"
              numberError={validationErrors.gpra_b_1a1}
              showRoute={substanceUse1?.gpra_b_1a1_days > 0}
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              summaryDisabled={disabled}
              daysSet={"gpra_b_1a2_days"}
              days={substanceUse1?.gpra_b_1a2_days}
              legend="Other"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1a2_route"}
              route={substanceUse1?.gpra_b_1a2_route}
              removeError={removeError}
              numberErrorType="gpra_b_1a2"
              numberError={validationErrors.gpra_b_1a2}
              showRoute={substanceUse1?.gpra_b_1a2_days > 0}
              showText={substanceUse1?.gpra_b_1a2_days > 0}
              text={substanceUse1?.gpra_b_1a2a}
              textError={validationErrors.gpra_b_1a2a}
              setText={"gpra_b_1a2a"}
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              defaultZero={question.defaultZero}
            />
          </AccordionTab>
        </Accordion>
      )
    }
    if (question.field === "gpra_b_1b1_days") {
      return (
        <Accordion activeIndex={0}>
          <AccordionTab header="Opioids">
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b1_days"}
              days={substanceUse1?.gpra_b_1b1_days}
              legend="Heroin"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b1_route"}
              route={substanceUse1?.gpra_b_1b1_route}
              removeError={removeError}
              numberErrorType="gpra_b_1b1"
              numberError={validationErrors.gpra_b_1b1}
              showRoute={substanceUse1?.gpra_b_1b1_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b2_days"}
              days={substanceUse1?.gpra_b_1b2_days}
              legend="Morphine"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b2_route"}
              route={substanceUse1?.gpra_b_1b2_route}
              removeError={removeError}
              numberErrorType="gpra_b_1b2"
              numberError={validationErrors.gpra_b_1b2}
              showRoute={substanceUse1?.gpra_b_1b2_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b3_days"}
              days={substanceUse1?.gpra_b_1b3_days}
              legend="Fentanyl (Prescription
      Diversion Or Illicit Source)"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b3_route"}
              route={substanceUse1?.gpra_b_1b3_route}
              removeError={removeError}
              numberErrorType="gpra_b_1b3"
              numberError={validationErrors.gpra_b_1b3}
              showRoute={substanceUse1?.gpra_b_1b3_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b4_days"}
              days={substanceUse1?.gpra_b_1b4_days}
              legend="Dilaudid"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b4_route"}
              route={substanceUse1?.gpra_b_1b4_route}
              removeError={removeError}
              numberErrorType="gpra_b_1b4"
              numberError={validationErrors.gpra_b_1b4}
              showRoute={substanceUse1?.gpra_b_1b4_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b5_days"}
              days={substanceUse1?.gpra_b_1b5_days}
              legend="Demerol"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b5_route"}
              route={substanceUse1?.gpra_b_1b5_route}
              removeError={removeError}
              numberErrorType="gpra_b_1b5"
              numberError={validationErrors.gpra_b_1b5}
              showRoute={substanceUse1?.gpra_b_1b5_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b6_days"}
              days={substanceUse1?.gpra_b_1b6_days}
              legend="Percocet"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b6_route"}
              route={substanceUse1?.gpra_b_1b6_route}
              removeError={removeError}
              numberErrorType="gpra_b_1b6"
              numberError={validationErrors.gpra_b_1b6}
              showRoute={substanceUse1?.gpra_b_1b6_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b7_days"}
              days={substanceUse1?.gpra_b_1b7_days}
              legend="Codeine"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b7_route"}
              route={substanceUse1?.gpra_b_1b7_route}
              removeError={removeError}
              numberErrorType="gpra_b_1b7"
              numberError={validationErrors.gpra_b_1b7}
              showRoute={substanceUse1?.gpra_b_1b7_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b8_days"}
              days={substanceUse1?.gpra_b_1b8_days}
              legend="Tylenol 2, 3, 4"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b8_route"}
              route={substanceUse1?.gpra_b_1b8_route}
              removeError={removeError}
              numberErrorType="gpra_b_1b8"
              numberError={validationErrors.gpra_b_1b8}
              showRoute={substanceUse1?.gpra_b_1b8_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b9_days"}
              days={substanceUse1?.gpra_b_1b9_days}
              legend="OxyContin/Oxycodone"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b9_route"}
              route={substanceUse1?.gpra_b_1b9_route}
              removeError={removeError}
              numberErrorType="gpra_b_1b9"
              numberError={validationErrors.gpra_b_1b9}
              showRoute={substanceUse1?.gpra_b_1b9_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b10_days"}
              days={substanceUse1?.gpra_b_1b10_days}
              legend="Non-prescription methadone"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b10_route"}
              route={"gpra_b_1b10_route"}
              removeError={removeError}
              numberErrorType="gpra_b_1b10"
              numberError={validationErrors.gpra_b_1b10}
              showRoute={substanceUse1?.gpra_b_1b10_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b11_days"}
              days={substanceUse1?.gpra_b_1b11_days}
              legend="Non-prescription buprenorphine"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b11_route"}
              route={substanceUse1?.gpra_b_1b11_route}
              removeError={removeError}
              numberErrorType="gpra_b_1b11"
              numberError={validationErrors.gpra_b_1b11}
              showRoute={substanceUse1?.gpra_b_1b11_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1b12_days"}
              days={substanceUse1?.gpra_b_1b12_days}
              legend="Other"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1b12_route"}
              route={substanceUse1?.gpra_b_1b12_route}
              removeError={removeError}
              numberErrorType="gpra_b_1b12"
              numberError={validationErrors.gpra_b_1b12}
              showRoute={substanceUse1?.gpra_b_1b12_days > 0}
              showText={substanceUse1?.gpra_b_1b12_days > 0}
              text={substanceUse1?.gpra_b_1b12a}
              textError={validationErrors.gpra_b_1b12a}
              setText={"gpra_b_1b12a"}
              defaultZero={question.defaultZero}
            />
          </AccordionTab>
        </Accordion>
      )
    }
    if (question.field === "gpra_b_1c1_days") {
      return (
        <Accordion activeIndex={0}>
          <AccordionTab header="Cannabis">
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1c1_days"}
              days={substanceUse1?.gpra_b_1c1_days}
              legend="Cannabis (Marijuana)"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1c1_route"}
              route={substanceUse1?.gpra_b_1c1_route}
              removeError={removeError}
              numberErrorType="gpra_b_1c1"
              numberError={validationErrors.gpra_b_1c1}
              showRoute={substanceUse1?.gpra_b_1c1_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1c2_days"}
              days={substanceUse1?.gpra_b_1c2_days}
              legend="Synthetic Cannabinoids"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1c2_route"}
              route={substanceUse1?.gpra_b_1c2_route}
              removeError={removeError}
              numberErrorType="gpra_b_1c2"
              numberError={validationErrors.gpra_b_1c2}
              showRoute={substanceUse1?.gpra_b_1c2_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1c3_days"}
              days={substanceUse1?.gpra_b_1c3_days}
              legend="Other"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1c3_route"}
              route={substanceUse1?.gpra_b_1c3_route}
              removeError={removeError}
              numberErrorType="gpra_b_1c3"
              numberError={validationErrors.gpra_b_1c3}
              showRoute={substanceUse1?.gpra_b_1c3_days > 0}
              showText={substanceUse1?.gpra_b_1c3_days > 0}
              text={substanceUse1?.gpra_b_1c3a}
              textError={validationErrors.gpra_b_1c3a}
              setText={"gpra_b_1c3a"}
              defaultZero={question.defaultZero}
            />
          </AccordionTab>
        </Accordion>
      )
    }
    if (question.field === "gpra_b_1d1_days") {
      return (
        <Accordion activeIndex={0}>
          <AccordionTab header="Sedative, Hypnotic, or Anxiolytics">
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1d1_days"}
              days={substanceUse1?.gpra_b_1d1_days}
              legend="Sedatives"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1d1_route"}
              route={substanceUse1?.gpra_b_1d1_route}
              removeError={removeError}
              numberErrorType="gpra_b_1d1"
              numberError={validationErrors.gpra_b_1d1}
              showRoute={substanceUse1?.gpra_b_1d1_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1d2_days"}
              days={substanceUse1?.gpra_b_1d2_days}
              legend="Hypnotics"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1d2_route"}
              route={substanceUse1?.gpra_b_1d2_route}
              removeError={removeError}
              numberErrorType="gpra_b_1d2"
              numberError={validationErrors.gpra_b_1d2}
              showRoute={substanceUse1?.gpra_b_1d2_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1d3_days"}
              days={substanceUse1?.gpra_b_1d3_days}
              legend="Barbiturates"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1d3_route"}
              route={substanceUse1?.gpra_b_1d3_route}
              removeError={removeError}
              numberErrorType="gpra_b_1d3"
              numberError={validationErrors.gpra_b_1d3}
              showRoute={substanceUse1?.gpra_b_1d3_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1d4_days"}
              days={substanceUse1?.gpra_b_1d4_days}
              legend="Anxiolytics/Benzodiazepines"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1d4_route"}
              route={substanceUse1?.gpra_b_1d4_route}
              removeError={removeError}
              numberErrorType="gpra_b_1d4"
              numberError={validationErrors.gpra_b_1d4}
              showRoute={substanceUse1?.gpra_b_1d4_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1d5_days"}
              days={substanceUse1?.gpra_b_1d5_days}
              legend="Other"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1d5_route"}
              route={substanceUse1?.gpra_b_1d5_route}
              removeError={removeError}
              numberErrorType="gpra_b_1d5"
              numberError={validationErrors.gpra_b_1d5}
              showRoute={substanceUse1?.gpra_b_1d5_days > 0}
              showText={substanceUse1?.gpra_b_1d5_days > 0}
              text={substanceUse1?.gpra_b_1d5a}
              textError={validationErrors.gpra_b_1d5a}
              setText={"gpra_b_1d5a"}
              defaultZero={question.defaultZero}
            />
          </AccordionTab>
        </Accordion>
      )
    }
    if (question.field === "gpra_b_1e1_days") {
      return (
        <Accordion activeIndex={0}>
          <AccordionTab header="Cocaine">
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1e1_days"}
              days={substanceUse1?.gpra_b_1e1_days}
              legend="Cocaine"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1e1_route"}
              route={substanceUse1?.gpra_b_1e1_route}
              removeError={removeError}
              numberErrorType="gpra_b_1e1"
              numberError={validationErrors.gpra_b_1e1}
              showRoute={substanceUse1?.gpra_b_1e1_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1e2_days"}
              days={substanceUse1?.gpra_b_1e2_days}
              legend="Crack"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1e2_route"}
              route={substanceUse1?.gpra_b_1e2_route}
              removeError={removeError}
              numberErrorType="gpra_b_1e2"
              numberError={validationErrors.gpra_b_1e2}
              showRoute={substanceUse1?.gpra_b_1e2_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1e3_days"}
              days={substanceUse1?.gpra_b_1e3_days}
              legend="Other"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1e3_route"}
              route={substanceUse1?.gpra_b_1e3_route}
              removeError={removeError}
              numberErrorType="gpra_b_1e3"
              numberError={validationErrors.gpra_b_1e3}
              showRoute={substanceUse1?.gpra_b_1e3_days > 0}
              showText={substanceUse1?.gpra_b_1e3_days > 0}
              text={substanceUse1?.gpra_b_1e3a}
              textError={validationErrors.gpra_b_1e3a}
              setText={"gpra_b_1e3a"}
              defaultZero={question.defaultZero}
            />
          </AccordionTab>
        </Accordion>
      )
    }
    if (question.field === "gpra_b_1f1_days") {
      return (
        <Accordion activeIndex={0}>
          <AccordionTab header="Other Stimulants">
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1f1_days"}
              days={substanceUse1?.gpra_b_1f1_days}
              legend="Methamphetamine"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1f1_route"}
              route={substanceUse1?.gpra_b_1f1_route}
              removeError={removeError}
              numberErrorType="gpra_b_1f1"
              numberError={validationErrors.gpra_b_1f1}
              showRoute={substanceUse1?.gpra_b_1f1_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1f2_days"}
              days={substanceUse1?.gpra_b_1f2_days}
              legend="Stimulant medications"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1f2_route"}
              route={substanceUse1?.gpra_b_1f2_route}
              removeError={removeError}
              numberErrorType="gpra_b_1f2"
              numberError={validationErrors.gpra_b_1f2}
              showRoute={substanceUse1?.gpra_b_1f2_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1f3_days"}
              days={substanceUse1?.gpra_b_1f3_days}
              legend="Other"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1f3_route"}
              route={substanceUse1?.gpra_b_1f3_route}
              removeError={removeError}
              numberErrorType="gpra_b_1f3"
              numberError={validationErrors.gpra_b_1f3}
              showRoute={substanceUse1?.gpra_b_1f3_days > 0}
              showText={substanceUse1?.gpra_b_1f3_days > 0}
              text={substanceUse1?.gpra_b_1f3a}
              textError={validationErrors.gpra_b_1f3a}
              setText={"gpra_b_1f3a"}
              defaultZero={question.defaultZero}
            />
          </AccordionTab>
        </Accordion>
      )
    }
    if (question.field === "gpra_b_1g1_days") {
      return (
        <Accordion activeIndex={0}>
          <AccordionTab header="Hallucinogens & Psychodelics">
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1g1_days"}
              days={substanceUse1?.gpra_b_1g1_days}
              legend="PCP"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1g1_route"}
              route={substanceUse1?.gpra_b_1g1_route}
              removeError={removeError}
              numberErrorType="gpra_b_1g1"
              numberError={validationErrors.gpra_b_1g1}
              showRoute={substanceUse1?.gpra_b_1g1_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1g2_days"}
              days={substanceUse1?.gpra_b_1g2_days}
              legend="MDMA"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1g2_route"}
              route={substanceUse1?.gpra_b_1g2_route}
              removeError={removeError}
              numberErrorType="gpra_b_1g2"
              numberError={validationErrors.gpra_b_1g2}
              showRoute={substanceUse1?.gpra_b_1g2_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1g3_days"}
              days={substanceUse1?.gpra_b_1g3_days}
              legend="LSD"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1g3_route"}
              route={substanceUse1?.gpra_b_1g3_route}
              removeError={removeError}
              numberErrorType="gpra_b_1g3"
              numberError={validationErrors.gpra_b_1g3}
              showRoute={substanceUse1?.gpra_b_1g3_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1g4_days"}
              days={substanceUse1?.gpra_b_1g4_days}
              legend="Mushrooms"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1g4_route"}
              route={substanceUse1?.gpra_b_1g4_route}
              removeError={removeError}
              numberErrorType="gpra_b_1g4"
              numberError={validationErrors.gpra_b_1g4}
              showRoute={substanceUse1?.gpra_b_1g4_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1g5_days"}
              days={substanceUse1?.gpra_b_1g5_days}
              legend="Mescaline"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1g5_route"}
              route={substanceUse1?.gpra_b_1g5_route}
              removeError={removeError}
              numberErrorType="gpra_b_1g5"
              numberError={validationErrors.gpra_b_1g5}
              showRoute={substanceUse1?.gpra_b_1g5_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              summaryDisabled={disabled}
              daysSet={"gpra_b_1g6_days"}
              days={substanceUse1?.gpra_b_1g6_days}
              legend="Salvia"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1g6_route"}
              route={substanceUse1?.gpra_b_1g6_route}
              removeError={removeError}
              numberErrorType="gpra_b_1g6"
              numberError={validationErrors.gpra_b_1g6}
              showRoute={substanceUse1?.gpra_b_1g6_days > 0}
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              summaryDisabled={disabled}
              daysSet={"gpra_b_1g7_days"}
              days={substanceUse1?.gpra_b_1g7_days}
              legend="DMT"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1g7_route"}
              route={substanceUse1?.gpra_b_1g7_route}
              removeError={removeError}
              numberErrorType="gpra_b_1g7"
              numberError={validationErrors.gpra_b_1g7}
              showRoute={substanceUse1?.gpra_b_1g7_days > 0}
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1g8_days"}
              days={substanceUse1?.gpra_b_1g8_days}
              legend="Other"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1g8_route"}
              route={substanceUse1?.gpra_b_1g8_route}
              removeError={removeError}
              numberErrorType="gpra_b_1g8"
              numberError={validationErrors.gpra_b_1g8}
              showRoute={substanceUse1?.gpra_b_1g8_days > 0}
              showText={substanceUse1?.gpra_b_1g8_days > 0}
              text={substanceUse1?.gpra_b_1g8a}
              textError={validationErrors.gpra_b_1g8a}
              setText={"gpra_b_1g8a"}
              defaultZero={question.defaultZero}
            />
          </AccordionTab>
        </Accordion>
      )
    }
    if (question.field === "gpra_b_1h1_days") {
      return (
        <Accordion activeIndex={0}>
          <AccordionTab header="Inhalants">
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1h1_days"}
              days={substanceUse1?.gpra_b_1h1_days}
              legend="Inhalants"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1h1_route"}
              route={substanceUse1?.gpra_b_1h1_route}
              removeError={removeError}
              numberErrorType="gpra_b_1h1"
              numberError={validationErrors.gpra_b_1h1}
              showRoute={substanceUse1?.gpra_b_1h1_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1h2_days"}
              days={substanceUse1?.gpra_b_1h2_days}
              legend="Other"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1h2_route"}
              route={substanceUse1?.gpra_b_1h2_route}
              removeError={removeError}
              numberErrorType="gpra_b_1h2"
              numberError={validationErrors.gpra_b_1h2}
              showRoute={substanceUse1?.gpra_b_1h2_days > 0}
              showText={substanceUse1?.gpra_b_1h2_days > 0}
              text={substanceUse1?.gpra_b_1h2a}
              textError={validationErrors.gpra_b_1h2a}
              setText={"gpra_b_1h2a"}
              defaultZero={question.defaultZero}
            />
          </AccordionTab>
        </Accordion>
      )
    }
    if (question.field === "gpra_b_1i1_days") {
      return (
        <Accordion activeIndex={0}>
          <AccordionTab header="Other Psychoactive Substances">
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1i1_days"}
              days={substanceUse1?.gpra_b_1i1_days}
              legend="Non-prescription GHB"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1i1_route"}
              route={substanceUse1?.gpra_b_1i1_route}
              removeError={removeError}
              numberErrorType="gpra_b_1i1"
              numberError={validationErrors.gpra_b_1i1}
              showRoute={substanceUse1?.gpra_b_1i1_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1i2_days"}
              days={substanceUse1?.gpra_b_1i2_days}
              legend="Ketamine"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1i2_route"}
              route={substanceUse1?.gpra_b_1i2_route}
              removeError={removeError}
              numberErrorType="gpra_b_1i2"
              numberError={validationErrors.gpra_b_1i2}
              showRoute={substanceUse1?.gpra_b_1i2_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1i3_days"}
              days={substanceUse1?.gpra_b_1i3_days}
              legend="MDPV/Bath Salts"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1i3_route"}
              route={substanceUse1?.gpra_b_1i3_route}
              removeError={removeError}
              numberErrorType="gpra_b_1i3"
              numberError={validationErrors.gpra_b_1i3}
              showRoute={substanceUse1?.gpra_b_1i3_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1i4_days"}
              days={substanceUse1?.gpra_b_1i4_days}
              legend="Kratom"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1i4_route"}
              route={substanceUse1?.gpra_b_1i4_route}
              removeError={removeError}
              numberErrorType="gpra_b_1i4"
              numberError={validationErrors.gpra_b_1i4}
              showRoute={substanceUse1?.gpra_b_1i4_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              summaryDisabled={disabled}
              daysSet={"gpra_b_1i5_days"}
              days={substanceUse1?.gpra_b_1i5_days}
              legend="Khat"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1i5_route"}
              route={substanceUse1?.gpra_b_1i5_route}
              removeError={removeError}
              numberErrorType="gpra_b_1i5"
              numberError={validationErrors.gpra_b_1i5}
              showRoute={substanceUse1?.gpra_b_1i5_days > 0}
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1i6_days"}
              days={substanceUse1?.gpra_b_1i6_days}
              legend="Other tranquilizers"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1i6_route"}
              route={substanceUse1?.gpra_b_1i6_route}
              removeError={removeError}
              numberErrorType="gpra_b_1i6"
              numberError={validationErrors.gpra_b_1i6}
              showRoute={substanceUse1?.gpra_b_1i6_days > 0}
              showText={substanceUse1?.gpra_b_1i6_days > 0}
              text={substanceUse1?.gpra_b_1i6a}
              textError={validationErrors.gpra_b_1i6a}
              setText={"gpra_b_1i6a"}
              textErrorType={"gpra_b_1i6a"}
              numberCallback={() => {
                updateState(
                  "gpra_b_1i6a",
                  "",
                  null,
                  null,
                  substanceUse1,
                  setSubstanceUse1,
                  null
                )
              }}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1i7_days"}
              days={substanceUse1?.gpra_b_1i7_days}
              legend="Other downers"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1i7_route"}
              route={substanceUse1?.gpra_b_1i7_route}
              removeError={removeError}
              numberErrorType="gpra_b_1i7"
              numberError={validationErrors.gpra_b_1i7}
              showRoute={substanceUse1?.gpra_b_1i7_days > 0}
              showText={substanceUse1?.gpra_b_1i7_days > 0}
              text={substanceUse1?.gpra_b_1i7a}
              textError={validationErrors.gpra_b_1i7a}
              setText={"gpra_b_1i7a"}
              textErrorType={"gpra_b_1i7a"}
              numberCallback={() => {
                updateState(
                  "gpra_b_1i7a",
                  "",
                  null,
                  null,
                  substanceUse1,
                  setSubstanceUse1,
                  null
                )
              }}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1i8_days"}
              days={substanceUse1?.gpra_b_1i8_days}
              legend="Other sedatives"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1i8_route"}
              route={substanceUse1?.gpra_b_1i8_route}
              removeError={removeError}
              numberErrorType="gpra_b_1i8"
              numberError={validationErrors.gpra_b_1i8}
              showRoute={substanceUse1?.gpra_b_1i8_days > 0}
              showText={substanceUse1?.gpra_b_1i8_days > 0}
              text={substanceUse1?.gpra_b_1i8a}
              textError={validationErrors.gpra_b_1i8a}
              setText={"gpra_b_1i8a"}
              textErrorType={"gpra_b_1i8a"}
              numberCallback={() => {
                updateState(
                  "gpra_b_1i8a",
                  "",
                  null,
                  null,
                  substanceUse1,
                  setSubstanceUse1,
                  null
                )
              }}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1i9_days"}
              days={substanceUse1?.gpra_b_1i9_days}
              legend="Other hypnotics"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1i9_route"}
              route={substanceUse1?.gpra_b_1i9_route}
              removeError={removeError}
              numberErrorType="gpra_b_1i9"
              numberError={validationErrors.gpra_b_1i9}
              showRoute={substanceUse1?.gpra_b_1i9_days > 0}
              showText={substanceUse1?.gpra_b_1i9_days > 0}
              text={substanceUse1?.gpra_b_1i9a}
              textError={validationErrors.gpra_b_1i9a}
              setText={"gpra_b_1i9a"}
              textErrorType={"gpra_b_1i9a"}
              numberCallback={() => {
                updateState(
                  "gpra_b_1i9a",
                  "",
                  null,
                  null,
                  substanceUse1,
                  setSubstanceUse1,
                  null
                )
              }}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1i10_days"}
              days={substanceUse1?.gpra_b_1i10_days}
              legend="Other"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1i10_route"}
              route={substanceUse1?.gpra_b_1i10_route}
              removeError={removeError}
              numberErrorType="gpra_b_1i10"
              numberError={validationErrors.gpra_b_1i10}
              showRoute={substanceUse1?.gpra_b_1i10_days > 0}
              showText={substanceUse1?.gpra_b_1i10_days > 0}
              text={substanceUse1?.gpra_b_1i10a}
              textError={validationErrors.gpra_b_1i10a}
              setText={"gpra_b_1i10a"}
              defaultZero={question.defaultZero}
            />
          </AccordionTab>
        </Accordion>
      )
    }
    if (question.field === "gpra_b_1j1_days") {
      return (
        <Accordion activeIndex={0}>
          <AccordionTab header="Tobacco and Nicotine">
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1j1_days"}
              days={substanceUse1?.gpra_b_1j1_days}
              legend="Tobacco"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1j1_route"}
              route={substanceUse1?.gpra_b_1j1_route}
              removeError={removeError}
              numberErrorType="gpra_b_1j1"
              numberError={validationErrors.gpra_b_1j1}
              showRoute={substanceUse1?.gpra_b_1j1_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1j2_days"}
              days={substanceUse1?.gpra_b_1j2_days}
              legend="Nicotine (Including Vape Products)"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1j2_route"}
              route={substanceUse1?.gpra_b_1j2_route}
              removeError={removeError}
              numberErrorType="gpra_b_1j2"
              numberError={validationErrors.gpra_b_1j2}
              showRoute={substanceUse1?.gpra_b_1j2_days > 0}
              defaultZero={question.defaultZero}
            />
            <SubstanceUseRow
              entity={substanceUse1}
              setEntity={setSubstanceUse1}
              summaryDisabled={disabled}
              daysSet={"gpra_b_1j3_days"}
              days={substanceUse1?.gpra_b_1j3_days}
              legend="Other"
              routeOptions={drugsAdministrationTypes}
              routeSet={"gpra_b_1j3_route"}
              route={substanceUse1?.gpra_b_1j3_route}
              removeError={removeError}
              numberErrorType="gpra_b_1j3"
              numberError={validationErrors.gpra_b_1j3}
              showRoute={substanceUse1?.gpra_b_1j3_days > 0}
              showText={substanceUse1?.gpra_b_1j3_days > 0}
              text={substanceUse1?.gpra_b_1j3a}
              textError={validationErrors.gpra_b_1j3a}
              setText={"gpra_b_1j3a"}
              defaultZero={question.defaultZero}
            />
          </AccordionTab>
        </Accordion>
      )
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraSytles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              saveData={saveData}
              nextForm={true}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="B. SUBSTANCE USE AND PLANNED SERVICES"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraSytles.grid}>
          <div className={gpraSytles.formRow}>
            <FormLabel
              label={
                "1. Using the options below, please indicate the following:"
              }
            />
            <FormLabel
              label={
                "A. The number of days, in the past 30 days, that the client reports using a substance."
              }
            />
            <FormLabel
              label={
                "The client should be encouraged to list the substances on their own. If they are unsure, the list from the options below can be read to the client. Please note that not all substance use is considered harmful or illicit – it may be that a substance is prescribed by a licensed provider, or that the client uses the substance in accordance with official, national safety guidelines. In such instances, clarification from the client should be sought, but if the substance is only taken as prescribed or used on each occasion in accordance with official, national safety guidelines, then it is not considered misuse. If no use of a listed substance is reported, please enter a zero (‘0’) in the corresponding ‘Number of Days Used’ column."
              }
              indent={false}
            />
            <FormLabel label={"B. The route by which the substance is used."} />
            <FormLabel
              label={
                "Mark one route only. But, if the client identifies more than one route, choose the corresponding route with the highest associated number value (numbers 1 – 6). Responses should capture the past 30 days of use."
              }
              indent={false}
            />
            <FormLabel
              label={
                "During the past 30 days, how many days have you used any of the following, and how do you take the substance?"
              }
              indent={false}
            />
          </div>
          <div className={gpraSytles.col12}>
            {mixedQuestions?.map((question) => {
              if (question.kind === "default") {
                if (question.show) {
                  return renderDefaultMain(question)
                }
              } else {
                if (
                  checkConditionalRender(
                    question.enabled,
                    question.required,
                    question.kind,
                    question.conditionalSource
                  )
                ) {
                  return (
                    <div style={{ marginBottom: "1rem" }}>
                      <AdditionalQuestionContainer
                        entity={substanceUse1}
                        setEntity={setSubstanceUse1}
                        errors={validationErrors}
                        section={INTERVIEW_SECTIONS.SUBSTANCE_USE_1}
                        removeError={removeError}
                        disabled={disabled}
                        question={question.question}
                        number={question.number}
                        kind={question.kind}
                      />
                    </div>
                  )
                } else {
                  if (checkDisplayConditional(question, substanceUse1)) {
                    return (
                      <div style={{ marginBottom: "1rem" }}>
                        <AdditionalQuestionContainer
                          entity={substanceUse1}
                          setEntity={setSubstanceUse1}
                          errors={validationErrors}
                          section={INTERVIEW_SECTIONS.SUBSTANCE_USE_1}
                          removeError={removeError}
                          disabled={disabled}
                          question={question.question}
                          number={question.number}
                          kind={question.kind}
                        />
                      </div>
                    )
                  }
                }
              }
            })}
          </div>
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraSytles.mt2}
          right={
            <CustomToolBar
              prevForm={true}
              saveData={saveData}
              nextForm={true}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
    </div>
  )
}

SubstanceUse1.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

SubstanceUse1.defaultProps = {
  showToolBar: true,
  disabled: false,
}
export default SubstanceUse1
